export default __webpack_public_path__ + "static/media/provider_5.2839b331.png";